import React from 'react';
import { PaginationParams } from '@/lib/types';
import { EmrClinicalNote } from '@/services/emrService';
import PatientClinicalNotesTab from './PatientClinicalNotesTab';

interface PatientNotesTabProps {
  patientId: string;
  isLoading: boolean;
  notes: EmrClinicalNote[];
  pagination: PaginationParams;
  onPaginationChange: (page: number) => void;
  refetch: () => void;
}

/**
 * Notes tab — top-level home for clinical-note authoring on the patient
 * detail page. Off-encounter notes here are typically administrative
 * (chart correction, letter, refill request, etc.) and don't get AI
 * autofill — IntelliHealth-backed SOAP drafting lives inside the visit
 * cockpit where an encounter is in scope.
 *
 * The chronological event Timeline lives in the secondary nav as its
 * own surface (it includes appointments, Rx, labs, intakes, status
 * changes — not just notes).
 */
export default function PatientNotesTab({
  patientId,
  isLoading,
  notes,
  pagination,
  onPaginationChange,
  refetch,
}: PatientNotesTabProps) {
  return (
    <PatientClinicalNotesTab
      isLoading={isLoading}
      notes={notes}
      pagination={pagination}
      onPaginationChange={onPaginationChange}
      refetch={refetch}
      patientId={patientId}
    />
  );
}
